import ArticleLinkBoxEditing from "./articleLinkBoxEditing"
import ArticleLinkBoxUi from "./articleLinkBoxUi"
import Plugin from "@ckeditor/ckeditor5-core/src/plugin"

export default class ArticleLinkBox extends Plugin {
  static get requires() {
    return [ArticleLinkBoxEditing, ArticleLinkBoxUi]
  }
}
